import script from "./RoleScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleScreen.vue?vue&type=script&setup=true&lang=ts"

import "./RoleScreen.vue?vue&type=style&index=0&id=7bfe4dd6&lang=scss"

const __exports__ = script;

export default __exports__